/** @jsx jsx */ import { jsx } from '@emotion/core'
import * as React from 'react'
import StyledComponent, { GetStylesType } from './StyledComponent'
import { Time as Tm } from '../Styles/index'
import { AudioContext } from '../Context'

const Time: React.FC<TimeProps> = ({ styles, remaining }) => {
  const { time, duration } = React.useContext(AudioContext)
  const m =
    '0' +
    Math.round(remaining ? ((duration - time) / 60) % 60 : (time / 60) % 60)
  const s = '0' + Math.round(remaining ? (duration - time) % 60 : time % 60)

  return (
    <StyledComponent styles={styles}>
      {({ getStyles }: { getStyles: GetStylesType }) => (
        <span css={getStyles('time', {})}>
          {m.substr(-2)}:{s.substr(-2)}
        </span>
      )}
    </StyledComponent>
  )
}

export default Time

interface TimeProps {
  styles?: Tm.StylesObj
  remaining?: boolean
}
